import axios from 'axios';

const BACKEND_URL = window.location.origin;
export const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const authAPI = {
  register: (email, password) => 
    apiClient.post('/auth/register', { email, password }),
  
  login: (email, password) => 
    apiClient.post('/auth/login', { email, password }),
  
  logout: () => 
    apiClient.post('/auth/logout', {}, { withCredentials: true }),
  
  getProfile: () => 
    apiClient.get('/user/profile'),
};

export const caseAPI = {
  checkCase: (receipt_number) => 
    apiClient.post('/check-case', { receipt_number }),
  
  getTrackedCases: () => 
    apiClient.get('/cases'),
  
  getCaseDetails: (caseId) => 
    apiClient.get(`/cases/${caseId}`),
  
  addTrackedCase: (receipt_number, nickname = null) => 
    apiClient.post('/cases', { receipt_number, nickname }),
  
  deleteCase: (caseId) => 
    apiClient.delete(`/cases/${caseId}`),
};

export const paymentAPI = {
  createCheckout: (origin_url) => 
    apiClient.post('/payments/checkout', { origin_url }),
  
  getPaymentStatus: (session_id) => 
    apiClient.get(`/payments/status/${session_id}`),
  
  createBillingPortal: (origin_url, return_url) =>
    apiClient.post('/billing/portal', { origin_url, return_url }),
};

export const settingsAPI = {
  getTrackingFrequency: () =>
    apiClient.get('/settings/tracking-frequency'),
  
  updateTrackingFrequency: (frequency) =>
    apiClient.put('/settings/tracking-frequency', { frequency }),
};

export default apiClient;
